import { useEffect, useState } from "react"
import { HomeGridBlock, HomeGridBlockBijoux, HomeGridBlockBridal, HomeGridBlockCelebrities } from "../components/homeGridBlock.component"
import collectionsJson from "../data/collections.json"
import bijouxJson from "../data/bijoux.json"
import { Link } from "react-router-dom"

export type Collection = {
    name: string,
    shortName: string,
    folder: string,
    addToCollectionMenu: boolean,
    photoBook: string,
    coverImage: string,
    collectionData: CollectionItem[],
    link?: string,
    /** Vertical alignment of cover image in homepage grid. Default: "top" */
    coverImagePosition?: 'top' | 'bottom'
}

export type CollectionItem = {
    title: string,
    images: string[]
}

export type Bijoux = {
    name: string,
    shortName: string,
    folder: string,
    coverImage: string,
    collectionData: BijouxItem[],
    description: string,
}

export type BijouxItem = {
    title: string,
    price: string,
    images: string[]
}

export function Home() {
    const [collections, setCollections] = useState<Collection[]>(collectionsJson as Collection[])

    useEffect(() => {
        let colections: Collection[] = collectionsJson as Collection[]
    }, [])

    return (
        <>
            <div className="container-fluid g-0">
                <div className="row g-0">
                    {
                        collections.map((c: Collection) => <HomeGridBlock key={c.shortName} {...c}/>)
                    }
                    <HomeGridBlockBijoux {...bijouxJson}/>
                    <HomeGridBlockBridal />
                    <HomeGridBlockCelebrities />
                </div>
            </div>

            <div className="container-fluid g-0 location-block" style={{position: "relative"}}>
                <Link to="about">
                    <img className="img-fluid" src="https://www.premio-architettura-toscana.it/wp-content/uploads/2022/02/17315-foto-02.jpg" />
                    <h1 className="home-grid-title">OUR ATELIER</h1>
                </Link>
            </div>
            
        </>
    )
}